import { QuickLookupElement } from "./QuickLookupElement";

class LookupActivator extends HTMLElement { 
    static tag = "lookup-activator";

    static initialize() {
        console.log("lookup-activator connected");

        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey && event.key === 'g') {
                if (document.querySelector(`${QuickLookupElement.tag}[show]`))
                    return;
                
                console.log("lookup-activator keydown");
                event.preventDefault();
                var element = new QuickLookupElement();
                document.body.append(element);

                requestAnimationFrame(() => {
                    element.toggleAttribute("show", true);
                });
            }
        });
    }
}

LookupActivator.initialize();